import { render, staticRenderFns } from "./zyz_tag_list.vue?vue&type=template&id=d7bcc754&scoped=true&"
import script from "./zyz_tag_list.vue?vue&type=script&lang=js&"
export * from "./zyz_tag_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bcc754",
  null
  
)

export default component.exports